import { defineMessages } from 'react-intl';

const messages = defineMessages({
	navbarRedeem: {
		id: 'giftCertificate.navbar.redeem',
		defaultMessage: 'Received a gift? <redeemlink>Redeem</redeemlink>',
		description: 'If they are redeeming, rather than purchasing, a gift card, they should click this link',
	},
	purchaseTitle: {
		id: 'giftCertificate.purchaseForm.title',
		defaultMessage: 'Give the Gift of Calm',
		description: 'Title of the section where they can purchase a Calm gift card (or multiple) to give',
	},
	purchaseConfirmationTitle: {
		id: 'giftCertificate.purchaseConfirmation.title',
		defaultMessage: 'Success!',
		description: 'Title of the success screen when the user successfully purchases a gift card',
	},
	purchaseConfirmationDescription: {
		id: 'giftCertificate.purchaseConfirmation.description',
		defaultMessage:
			"Thanks for purchasing a year of Calm. We’ve emailed a confirmation to {email} with the {quantity, plural, one {certificate} other {certificates}} and all the details. If you've made a mistake, contact us <herelink>here</herelink>.",
		description: 'Description on the success screen when the user successfully purchases a gift card',
	},
	purchaseLifetimeConfirmationDescription: {
		id: 'giftCertificate.purchaseLifetimeConfirmation.description',
		defaultMessage:
			"Thanks for purchasing a lifetime of Calm. We’ve emailed a confirmation to {email} with the {quantity, plural, one {certificate} other {certificates}} and all the details. If you've made a mistake, contact us <herelink>here</herelink>.",
		description: 'Description on the success screen when the user successfully purchases a gift card',
	},
	quantitySelectorTitle: {
		id: 'giftCertificate.quantitySelector.title',
		defaultMessage: 'Quantity:',
		description: 'Label for the gift card quantity selector',
	},
	quantitySelectorNumFree: {
		id: 'giftCertificate.quantitySelector.numFree',
		defaultMessage: '+ {numFree} FREE',
		description:
			'Explain to the user that when they purchase enough gift cards, they get additional ones for free',
	},
	quantitySelectorPrice: {
		id: 'giftCertificate.quantitySelector.price',
		defaultMessage: '{price}',
		description: 'The price of cart full of gift cards',
	},
	howItWorksTitle: {
		id: 'sections.howItWorks.title',
		defaultMessage: 'How it works',
		description: 'Title for the section explaining how to give a Calm gift card',
	},
	howItWorksPurchaseStepTitle: {
		id: 'sections.howItWorks.purchase.title',
		defaultMessage: '1. Purchase',
		description: 'The first step to give a gift card is to purchase the gift card',
	},
	howItWorksPurchaseStepDescription: {
		id: 'sections.howItWorks.purchase.description',
		defaultMessage: 'Buy the gift of Calm for your friends and family',
		description: 'The first step to give a gift card is to purchase the gift card',
	},
	howItWorksSendStepTitle: {
		id: 'sections.howItWorks.send.title',
		defaultMessage: '2. Send',
		description: 'The second step to give a gift card is to send the gift card',
	},
	howItWorksSendStepDescription: {
		id: 'sections.howItWorks.send.description',
		defaultMessage: 'You get a beautiful gift certificate that you can print out or e-mail',
		description: 'The second step to give a gift card is to send the gift card',
	},
	howItWorksRedeemStepTitle: {
		id: 'sections.howItWorks.unlock.title',
		defaultMessage: '3. Redeem',
		description: 'The third and final step to give a gift card is to have the recipient redeem the gift card',
	},
	howItWorksRedeemStepDescription: {
		id: 'sections.howItWorks.unlock.descriptionNew',
		defaultMessage: 'Recipients can use their gift code to easily unlock a year or lifetime of Calm',
		description: 'The third and final step to give a gift card is to have the recipient redeem the gift card',
	},
	premiumTitle: {
		id: 'homepage.splash.premium.title',
		defaultMessage: 'Unlock Calm Premium',
		description: 'Title for the section explaining why you should get Calm Premium',
	},
	premiumReasonOne: {
		id: 'homepage.splash.premium.reason1',
		defaultMessage: 'An original Daily Calm every day',
		description: 'Get Calm Premium for this reason',
	},
	premiumReasonTwo: {
		id: 'homepage.splash.premium.reason2',
		defaultMessage: '100+ guided meditations covering anxiety, focus, stress, sleep, relationships and more',
		description: 'Get Calm Premium for this reason',
	},
	premiumReasonThree: {
		id: 'homepage.splash.premium.reason3',
		defaultMessage: 'Entire library of Sleep Stories, with new stories added every week',
		description: 'Get Calm Premium for this reason',
	},
	premiumReasonFour: {
		id: 'homepage.splash.premium.simpleHomepageReason4',
		defaultMessage: 'Exclusive music tracks for Focus, Relaxation and Sleep',
		description: 'Get Calm Premium for this reason',
	},
	premiumReasonFive: {
		id: 'homepage.splash.premium.masterclassReason',
		defaultMessage: 'Life-changing Calm Masterclasses taught by world-renowned experts',
		description: 'Get Calm Premium for this reason',
	},
	premiumReasonSix: {
		id: 'homepage.splash.premium.reason6',
		defaultMessage: 'Access to all Calm Body programs',
		description: 'Get Calm Premium for this reason',
	},
	redeemTitle: {
		id: 'redeem.title',
		defaultMessage: 'Redeem Your Calm Gift Card',
		description: 'Title of the section where they can redeem a Calm gift card',
	},
	redeemedTitle: {
		id: 'redeem.redeemedTitle',
		defaultMessage: 'Welcome to Calm!',
		description: 'Title of the section once they have redeemed a Calm gift card',
	},
	redeemAlreadySubscribedTitle: {
		id: 'redeem.redeemFlow.alreadySubscribed.title',
		defaultMessage: 'You are already subscribed',
		description: 'They cannot redeem a gift card if they already have a subscription',
	},
	redeemAlreadySubscribed: {
		id: 'redeem.redeemFlow.alreadySubscribed.description',
		defaultMessage:
			'You already have a Calm Premium subscription, so you can’t redeem this gift right now. You can learn more about your own subscription <subscriptionlink>here</subscriptionlink>.',
		description: 'They cannot redeem a gift card if they already have a subscription',
	},
	questions: {
		id: 'shared.header.questions',
		defaultMessage: 'Questions?',
		description: 'Prompt for them to click a nearby button if they are having issues or have questions',
	},
	contact: {
		id: 'shared.header.contactUs',
		defaultMessage: 'Contact Us',
		description: 'Prompt for them to click this button if they are having issues or have questions',
	},
	logOut: {
		id: 'generics.logout',
		defaultMessage: 'Log Out',
		description: 'Prompt for them to click this button if they want to log out',
	},
	b2bUpsellMessage: {
		id: 'b2bupsell.message',
		defaultMessage:
			'Buying for your team or colleagues? Check out the savings available from <b2bLink>Calm Business</b2bLink> to bring our wellness solution to your workplace.',
		description:
			'Note for user to check out Calm Business if they are purchasing a large number of gift cards',
	},
});

export default messages;
